import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { RestProviderService } from 'src/app/shared/services/rest-provider.service';
import { SharedService } from 'src/app/shared/services/shared.service';
import { UsuarioBean } from 'src/app/_beans/UsuarioBean';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-recuperar-clave-dialog',
  templateUrl: './recuperar-clave-dialog.component.html',
  styleUrls: ['./recuperar-clave-dialog.component.scss']
})
export class RecuperarClaveDialogComponent implements OnInit {
  email: string;

  constructor(
    public dialogRef: MatDialogRef<RecuperarClaveDialogComponent>,
    private sharedService: SharedService,
    private restProvider: RestProviderService,
  ) { }

  ngOnInit(): void {
  }

  public guardar() {
    let user: UsuarioBean= new UsuarioBean();
    user.email=this.email;
    let params = {
      data: user
    }
    this.restProvider.executeHttpMethod("/uc/rc", params).subscribe((result: any) => {
      Swal.fire('Contraseña actualizada', 'Se le envió su nueva contraseña al correo '+this.email, 'info');
      this.cerrar();
    }, error => {
      Swal.fire('Error', 'El correo enviado no existe', 'error');
      console.error(error);
      this.cerrar();
    });
  }

  public datosCompletados() {
    return !(this.email  && this.sharedService.validateEmailFormat(this.email));
  }

  public cerrar() {
    this.dialogRef.close();
  }


}
